<template>
  <b-row>
    <b-col sm="12" md="8">
      <my-card :isloading="cardloading">
        <template slot="body">
          <form-validation @submit="submitForm">
            <b-row>
              <b-col sm="12" md="8">
                <form-input :rules="{required: true}" v-model="code" label="Kode"></form-input>
              </b-col>
              <b-col sm="12">
                <form-input :rules="{required: true}" v-model="name" label="Nama Mitra"></form-input>
              </b-col>
              <b-col sm="12">
                <form-input :rules="{required: false}" v-model="note" label="Keterangan"></form-input>
              </b-col>
              <b-col sm="12">
                <form-checkbox label="Aktif" v-model="is_active"></form-checkbox>
              </b-col>
              <b-col sm="12">
                <form-checkbox label="Tipe Kas" v-model="is_cash"></form-checkbox>
              </b-col>
              <b-col sm="12" class="mt-3">
                <button-save :isloading="isloading"></button-save>
                <button-back class="ml-1" :to="{name:'partners'}"></button-back>
              </b-col>
            </b-row>
          </form-validation>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import FormInput from '@/my-components/FormInput.vue'
import FormCheckbox from '@/my-components/FormCheckbox.vue'
import ButtonSave from '@/my-components/ButtonSave.vue'
import ButtonBack from '@/my-components/ButtonBack.vue'
import { mapActions } from 'vuex'
import FormValidation from '@/my-components/FormValidation.vue'

export default {
  components:{
    FormInput,
    ButtonSave,
    ButtonBack,
    FormValidation,
    FormCheckbox
  },
  data(){
    return {
      id: this.$route.params.id||null,
      code:'',
      name:'',
      note:'',
      is_cash: false,
      is_active: true,
      isloading: false,
      cardloading: false
    }
  },
  methods:{
    ...mapActions({
      dispatchStore: 'partners/store',
      dispatchShow: 'partners/show',
      dispatchUpdate: 'partners/update',
    }),
    cityChange(json){
      if(json.label) this.name_city = json.label;
      else this.name_city = '';
    },
    async getData(){
      this.cardloading = true
      const data = await this.dispatchShow(this.id)
      this.name = data.name
      this.code = data.code
      this.is_active = data.is_active ? true : false
      this.is_cash = data.is_cash ? true : false
      this.note = data.note
      this.cardloading = false
    },
    async submitForm(){
      this.isloading = true
      const {id,code,name,note} = this
      let params = {id,code,name,note}
      params.is_active = this.is_active ? 1 : 0
      params.is_cash = this.is_cash ? 1 : 0
      try {
        if (this.id) await this.dispatchUpdate(params);
        else await this.dispatchStore(params);
        this.toastSuccess("OK","Data berhasil disimpan!")
        this.$router.push({name:'partners'})
      } catch (error) {
        this.handleError(error)
      }
      this.isloading = false
    },
  },
  mounted(){
    if(this.id) return this.getData();
  }
}
</script>

<style>

</style>